import { useEffect, type HTMLAttributes, type ReactNode } from 'react'

import { Icon } from './Icon'
import styles from './Toast.module.css'

export interface ToastProps extends HTMLAttributes<HTMLSpanElement> {
  duration?: number
  onDismiss?: () => void
  animate?: boolean
}

export function Toast({ duration = 3000, onDismiss, animate = true, children, className = '', ...props }: ToastProps) {
  useEffect(() => {
    if (!onDismiss) return
    const timer = window.setTimeout(onDismiss, duration)
    return () => window.clearTimeout(timer)
  }, [duration, onDismiss])

  return (
    <span className={`${styles.toast} ${animate ? styles.animated : ''} ${className}`} role="status" {...props}>
      <span className={styles.icon}><Icon name="check-circle" size={18} strokeWidth={2} /></span>
      {children}
    </span>
  )
}

export interface ToastHostProps {
  children: ReactNode
  inline?: boolean
}

export function ToastHost({ children, inline = false }: ToastHostProps) {
  return <div className={`${styles.host} ${inline ? styles.inline : ''}`}>{children}</div>
}
